import { createApi } from "@reduxjs/toolkit/query/react";
import { components, operations } from "../../types/api";
import { baseQueryWithReauth } from "../../utils/baseQuery";

type ApiResponseFormattedInternalCampaign =
  components["schemas"]["ApiResponse_FormattedInternalCampaign_"];
type ApiResponsePaginatedInternalCampaigns =
  components["schemas"]["ApiResponse_PaginatedResult_FormattedInternalCampaign__"];
type ListInternalCampaignsAdminQueryParams =
  operations["ListInternalCampaignsAdmin"]["parameters"]["query"];

export const internalCampaignApi = createApi({
  reducerPath: "internalCampaignApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["InternalCampaign"],
  endpoints: (builder) => ({
    // List internal campaigns (Admin only) with pagination and optional search filters
    getInternalCampaignsAdmin: builder.query<
      ApiResponsePaginatedInternalCampaigns,
      ListInternalCampaignsAdminQueryParams | void
    >({
      query: (params) => ({
        url: "/internal-campaigns",
        params: params || {},
      }),
      providesTags: [{ type: "InternalCampaign", id: "LIST" }],
    }),
    // Get internal campaign by ID
    getInternalCampaignById: builder.query<
      ApiResponseFormattedInternalCampaign,
      string
    >({
      query: (id) => `/internal-campaigns/${id}`,
      providesTags: (result, error, id) => [{ type: "InternalCampaign", id }],
    }),
    // Migrate orphaned internal campaigns
    migrateOrphanCampaigns: builder.mutation<
      components["schemas"]["ApiResponse__totalAffected-number--totalOrphans-number--details-string-Array__"],
      void
    >({
      query: () => ({
        url: "/internal-campaigns/admin/migrate-orphans",
        method: "POST",
      }),
      invalidatesTags: [{ type: "InternalCampaign", id: "LIST" }],
    }),
  }),
});

export const {
  useGetInternalCampaignsAdminQuery,
  useGetInternalCampaignByIdQuery,
  useMigrateOrphanCampaignsMutation,
} = internalCampaignApi;
